import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Paper, Grid } from '@material-ui/core';

const StyledGrid = withStyles({
    root: {
        paddingTop: 20,
        paddingRight: 15,
        paddingLeft: 15,
        paddingBottom: 5,
    },
})(Grid);

export default function KidCard(props) {
    return (
        <StyledGrid container spacing={1}>
            {props.children}
        </StyledGrid>
    );
}
